import React from 'react';
import { IconProps } from '../types';
const MinecraftTorchflowerSeeds: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="1" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(35, 111, 75, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(35, 111, 75, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(28, 89, 56, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(40, 131, 92, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(34, 110, 74, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(28, 89, 56, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(40, 131, 92, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(35, 111, 75, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(35, 111, 75, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(35, 111, 75, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(40, 131, 92, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(20, 70, 51, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(40, 131, 92, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(211, 186, 84, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(40, 131, 92, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(29, 90, 57, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(211, 186, 84, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(211, 186, 84, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(133, 139, 78, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(173, 164, 82, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(119, 109, 70, 255)" />
</svg>);
export default MinecraftTorchflowerSeeds;